<template>
  <v-app-bar flat height="80px" max-height="80px"  :color="color" >
      <v-row class="d-flex align-center">
        <v-col cols="4" md="3" lg="2">
          <v-img
            class="ml-1"
            :max-width="logoWidth"
            height="auto"
            :src="logo"
          ></v-img>
        </v-col>
        <v-col cols="8" md="9">
          <slot />
        </v-col>
      </v-row>
 
  </v-app-bar>
</template>

<script>
export default {
  props:{
    color: String
  },
  data: () => ({
    logo: require("@/assets/images/shuttle-central.png"),
  }),
  computed: {
    logoWidth: (vm) => {
      const { xs, sm, md } = vm.$vuetify.breakpoint;
      if (xs) return "120px";
      if (sm) return "120px";
      if (md) return "150px";
      return "150px";
    },
  },
};
</script>
